import { AbstractControl, ValidationErrors } from '@angular/forms';

import { validate } from 'cnpj';

export class CnpjValidator {

  static cnpjInvalido(ac: AbstractControl): ValidationErrors | null {

    return ac.value && ac.value.length === 18 && !validate(ac.value) ? { cnpjInvalido: true } : null;

  }

}
